import { render, staticRenderFns } from "./CourseApplyDialog.vue?vue&type=template&id=cc88c28a&scoped=true"
import script from "./CourseApplyDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseApplyDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CourseApplyDialog.vue?vue&type=style&index=0&id=cc88c28a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc88c28a",
  null
  
)

export default component.exports